// Toss throws an error to the error handling client.
// TODO: plug in
export const Toss = (fnName, fnArgs, err) => {
  const thing = fnName;
  return [thing, err];
};
